$(function () {
  if (!customElements.get('drawer-login')) {
    customElements.define(
      'drawer-login',
      class drawerLogin extends HTMLElement {
        constructor() {
          super();
          this.$headerContainer = null;
          this.$drawerClose = null;
          this.$drawerLogin = null;
          this.$MainContent = null;
          this.$overlay = null;
          this.$body = null;
        }

        connectedCallback() {
          this.$MainContent = $('#MainContent');
          this.$body = $('body');
          this.init();
          this.drawerInit();
          this.drawerClose();
        }
        disconnectedCallback() {}
        init() {
          const root = $(this);
          const $inputDom = root.find('.input_text');
          const $formDom = root.find('form');
          const $submitButton = root.find('.login-submit');
          let emailValid = '';
          let passwordValid = '';
          $submitButton.on('click', (event) => {
            event.preventDefault();
            $inputDom.parents('.input_text_container').each(function () {
              const input_text = $(this).find('.input_text').val(); // 获取当前输入框的值

              const rule = $(this).data('rule'); // 获取当前规则
              let isValid = true; // 默认设置为有效

              if (rule) {
                if (rule === 'email' && ltUtils.rule.email.test(input_text)) {
                  emailValid = ltUtils.rule.email.test(input_text);
                } else if (rule === 'password' && ltUtils.rule.password.test(input_text)) {
                  passwordValid = ltUtils.rule.password.test(input_text);
                } else {
                  isValid = false; // 如果验证不通过，设置为无效
                  $(this).attr('data-error', 'true'); // 设置错误标志
                }
              }

              if (emailValid && passwordValid) {
                $formDom.submit(); // 如果两个条件都满足，提交表单
              }
            });
          });
        }
        // 导航中弹窗逻辑
        drawerInit() {
          this.$drawerLogin = $('#drawer-login')[0];
          this.$loginButton = $('.header__icon-wrapper')[0];

          customEventListener(this.$loginButton, 'click', () => {
            if (this.$drawerLogin.classList.contains('drawer-close')) {
              this.$drawerLogin.classList.remove('drawer-close');
            }
            this.$drawerLogin.toggleAttribute('open');

            if (this.$MainContent.length > 0) {
              this.$body.addClass('body-no-scroll');
              // 使用全局遮罩层管理器
              this.$overlay = window.overlayManager.show();

              customEventListener(this.$overlay[0], 'click', () => {
                window.overlayManager.hide();
                this.$body.removeClass('body-no-scroll');
                this.$drawerLogin.removeAttribute('open');
                this.$drawerLogin.classList.add('drawer-close');
              });
            }
          });
        }
        drawerClose() {
          this.$drawerClose = this.querySelector('.drawer-close');
          customEventListener(this.$drawerClose, 'click', () => {
            window.overlayManager.hide(); // 使用全局遮罩层管理器
            this.$body.removeClass('body-no-scroll');
            this.$drawerLogin.removeAttribute('open');
            this.$drawerLogin.classList.add('drawer-close');
          });
        }
      }
    );
  }
});
